module.exports = __webpack_public_path__ + "img/ve.0cf42924.svg";